import React from 'react';
// Custom
import { profileDataShape } from 'constants/PropTypesShapes';
import PermissionsList from 'profiles/assets/permissions/PermissionsList';

const ProfilePermissions = ({ profile }) => (
  <PermissionsList
    product={profile.product}
    profilePermissions={profile.permissions}
    withCheckIcon
  />
);

ProfilePermissions.propTypes = {
  profile: profileDataShape.isRequired,
};

module.exports = ProfilePermissions;



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/assets/main/ProfilePermissions.js